@let isCreating =
  scenariosFeature.selectors.isCreatingScenario.asSignal();

@if (scenariosFeature.selectors.editingScenarioDraft.asSignal()) {
  <atn-ds-centered-overlay>
    <atn-ds-widget
      title="Scenario"
      class="atn-scenario-edit-dialog"
    >
      <atn-ds-integrated-vertical-tabs>
        <ng-template
          atnDsTab
          name="General"
        >
          <atn-scenario-general-tab />
        </ng-template>

        <!-- TODO: back-end doesn't support updating scenario data related properties -->
        @if (isCreating) {
          <ng-template
            atnDsTab
            name="Data"
          >
            <atn-scenario-data-tab />
          </ng-template>
        }

        @if (selectedAppHasVariablesSg()) {
          <ng-template
            atnDsTab
            name="Variables"
          >
            <atn-scenario-variables-tab />
          </ng-template>
        }
      </atn-ds-integrated-vertical-tabs>
      @if (scenariosFeature.selectors.editError.asSignal()) {
        <div class="atn-scenario-edit-dialog__error">
          Something went wrong while saving the scenario. Please try again.
        </div>
      }
      <div
        footer
        class="atn-scenario-edit-dialog__footer"
      >
        <atn-ds-button
          class="atn-scenario-edit-dialog__footer-cancel-btn"
          type="transparent"
          (click)="cancelClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          [loading]="scenariosFeature.selectors.isSubmittingEdit.asSignal()"
          (click)="saveClickHandler()"
        >
          {{ isCreating ? 'Create' : 'Update' }}
        </atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
